<div class="row mt-5 justify-content-end mb-4">
  <div class="col-md-4">
      <div class="row mt-2">
          <div class="col-md-5">Ukupno:</div>
          <div class="col-md-6 text-right font-weight-bold border">{{iznos}}</div>
      </div>
  </div>
</div>